import { LocalizationStatus } from 'libs.localization.common';
/**
 * Validates the L10N_MAP against all assets.
 * If an asset locale is "ready", it must have an entry in L10N_MAP with a non-null translationId.
 * L10N_MAP may contain entries with other statuses, but we only validate ready locales.
 *
 * @param l10nMap - The L10N_MAP array to validate
 * @param allAssets - All assets to validate against
 * @returns Validation result with isValid flag and array of errors
 */
export function validateL10nMap(l10nMap, allAssets) {
    const errors = [];
    if (!l10nMap || !Array.isArray(l10nMap)) {
        return { isValid: true, errors: [] };
    }
    // Iterate through all assets
    Object.values(allAssets).forEach((asset) => {
        const { translationWorkbenchId } = asset;
        if (!translationWorkbenchId) {
            return;
        }
        // Check all "ready" locales - they must have entries in L10N_MAP with non-null translationId
        const readyLocales = Object.entries(asset.currentVersionStatus || {}).filter(([, versionStatus]) => versionStatus.status === LocalizationStatus.READY);
        readyLocales.forEach(([locale]) => {
            const l10nMapEntry = l10nMap.find((entry) => entry.translationWorkbenchId === translationWorkbenchId && entry.locale === locale);
            if (!l10nMapEntry) {
                errors.push({
                    translationWorkbenchId,
                    locale: locale,
                    status: LocalizationStatus.READY,
                    message: `Missing L10N_MAP entry for ready locale (translationWorkbenchId: ${translationWorkbenchId}, locale: ${locale})`,
                });
                return;
            }
            // Validate that translationId is not null for ready locales
            if (!l10nMapEntry.translationId) {
                errors.push({
                    translationWorkbenchId,
                    locale: locale,
                    status: LocalizationStatus.READY,
                    message: `Missing translationId for ready status entry (translationWorkbenchId: ${translationWorkbenchId}, locale: ${locale})`,
                });
            }
            // Also validate resourceId for ready locales
            if (!l10nMapEntry.resourceId) {
                errors.push({
                    translationWorkbenchId,
                    locale: locale,
                    status: LocalizationStatus.READY,
                    message: `Missing resourceId for ready status entry (translationWorkbenchId: ${translationWorkbenchId}, locale: ${locale})`,
                });
            }
        });
    });
    return {
        isValid: errors.length === 0,
        errors,
    };
}
